module.exports = __webpack_public_path__ + "img/bell_color.15e99b9f.svg";